import type { AxiosResponse } from 'axios';

export function downloadFile(response: AxiosResponse, fileName: string) {
  const type = response.headers['content-type'];
  const fileNameFromApi = response.headers['content-disposition']?.split('filename=')[1];
  const blob = new Blob([response.data], { type });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = fileNameFromApi || fileName;
  link.click();
  URL.revokeObjectURL(link.href);
  link.remove();
}
